import styled from "styled-components";
import MainNavbar from "./mocks/navBar/MainNavbar";

const Container = styled.div`
  width: 100%;
  margin-bottom: 15px;
`;

type WebBarPreviewsProps = {
  className?: string;
};

export default function WebBarPreviews({ className }: WebBarPreviewsProps) {
  return (
    <Container className={className}>
      <MainNavbar />
    </Container>
  );
}
